import { server } from '../constants';
import { httpClient } from './../utils/HttpClient';

// Category data model

/**
 * getListAll(), getListAll category for reporter
 * Method: GET
 * @returns
 */
export function getListAll(params = { lang: 'TH' }) {
  return httpClient
    .get(`${server.CATEGORY_URL}/getListAll/${params.lang}`)
    .then((result) => {
      return result.data.content;
    })
    .catch((error) => {
      throw error;
    });
}

/**
 * getList(), getList category by permission (for staff)
 * @param {object} params
 * @param {string} params.package base64 of props {lang, dateStart, dateEnd, category_id }
 * @returns
 * API Doc: muit-iDev/pdpa-im-api/-/wikis/Master/Category#getlist
 */
export function getList(params) {
  return httpClient
    .get(`${server.CATEGORY_URL}/getList`, { params })
    .then((result) => {
      return result.data.content;
    })
    .catch((error) => {
      throw error;
    });
}
